import { render } from "./ForgotPassword.vue?vue&type=template&id=3c9d7d36"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"
script.render = render

export default script